/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-22 10:39:01
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-26 18:02:37
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/HotTags/TagDragContainer/index.tsx
 */
import React from 'react';

//import css from './SalesChannelEditorPromotion.less';

import TextAndEditIcon from '@/src/components/DragRowDisplay/TextAndEditIcon';
import DragNDropColumns from 'src/components/DragNDropColumns';
import SetHotTags from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/HotTags/SetHotTags';
// import { ActionType, EnumPosition } from 'src/types/common/common';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const TagDragContainer = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { droppableId, data, onChange, onSort, onDelete } = props;
  const [visible, setVisible] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState({});
  const childGenerate = (data, index) => {
    const { title } = data || {};
    return (
      <TextAndEditIcon
        name={title}
        onClick={() => {
          handleOnSelect(data, index);
        }}
      />
    );
  };
  const handleOnSelect = (data, index) => {
    setSelectedItem({ ...(data || {}), index });
    openModal();
  };

  const _onSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};

    if (onSort) onSort(oldIndex, newIndex);
  };
  const _onDelete = (index) => {
    if (onDelete) onDelete(index);
  };
  const openModal = () => {
    setVisible(true);
  };
  const handleOnCancel = () => {
    setVisible(false);
  };
  const handleOnOk = (data, index) => {
    if (onChange) {
      onChange(data, index);
    }
    setVisible(false);
  };
  const addTextOnClick = () => {
    setSelectedItem({ index: undefined });
    openModal();
  };
  return (
    <React.Fragment>
      {visible && (
        <SetHotTags
          visible={visible}
          onOk={handleOnOk}
          onCancel={handleOnCancel}
          data={selectedItem || {}}
        />
      )}

      <DragNDropColumns
        hideTitle
        childGenerate={childGenerate}
        onDelete={_onDelete}
        data={data}
        droppableId={droppableId}
        onSort={_onSort}
        onAdd={addTextOnClick}
        addText={`+ ${getI18n('salesChannelContent.index.addHottag')}`}
      />
    </React.Fragment>
  );
};
export default TagDragContainer;
